export const UPLOAD_MONITORING_OLD_DATA_REQUEST = "UPLOAD_MONITORING_OLD_DATA_REQUEST";
export const UPLOAD_MONITORING_OLD_DATA_RESPONSE = "UPLOAD_MONITORING_OLD_DATA_RESPONSE";

export const MONITORING_DOWNLOAD_COUNTERPARTY_DATA_REQUEST ="MONITORING_DOWNLOAD_COUNTERPARTY_DATA_REQUEST";
export const MONITORING_DOWNLOAD_COUNTERPARTY_DATA_RESPONSE = "MONITORING_DOWNLOAD_COUNTERPARTY_DATA_RESPONSE";

export const FETCH_MONITORING_LIST_REQUEST = "FETCH_MONITORING_LIST_REQUEST";
export const FETCH_MONITORING_LIST_RESPONSE = "FETCH_MONITORING_LIST_RESPONSE";

export const CREATE_MONITORING_METADATA_REQUEST = "CREATE_MONITORING_METADATA_REQUEST";
export const CREATE_MONITORING_METADATA_RESPONSE = "CREATE_MONITORING_METADATA_RESPONSE";

export const UPLOAD_MONITORING_DATA_REQUEST = "UPLOAD_MONITORING_DATA_REQUEST";
export const UPLOAD_MONITORING_DATA_RESPONSE = "UPLOAD_MONITORING_DATA_RESPONSE";
export const UPLOAD_MONITORING_TEMPLATE_REQUEST = "UPLOAD_MONITORING_TEMPLATE_REQUEST";
export const UPLOAD_MONITORING_TEMPLATE_RESPONSE = "UPLOAD_MONITORING_TEMPLATE_RESPONSE";

export const STOP_MONITORING_REQUEST = "STOP_MONITORING_REQUEST";
export const INITIATE_MONITORING_REQUEST = "INITIATE_MONITORING_REQUEST";
export const STOP_MONITORING_RESPONSE = "STOP_MONITORING_RESPONSE";
export const INITIATE_MONITORING_RESPONSE = "INITIATE_MONITORING_RESPONSE";

export const DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_REQUEST = "DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_REQUEST";
export const DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_RESPONSE = "DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_RESPONSE";
export const DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_REQUEST = "DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_REQUEST";
export const DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_RESPONSE ="DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_RESPONSE";

export const uploadMonitoringDataRequest = (data) => {
    return {
        type: UPLOAD_MONITORING_OLD_DATA_REQUEST,
        data
    }
}

export const uploadMonitoringDataResponse = (data) => {
    return {
        type: UPLOAD_MONITORING_OLD_DATA_RESPONSE,
        data
    }
}

export const downloadMonitoringCounterpartyDataRequest = (data) => {
    return {
        type: MONITORING_DOWNLOAD_COUNTERPARTY_DATA_REQUEST,
        data
    }
}

export const downloadMonitoringCounterpartyDataResponse = (data) => {
    return {
        type: MONITORING_DOWNLOAD_COUNTERPARTY_DATA_RESPONSE,
        data
    }
}

export const fetchMonitoringListRequest = (data) => {
    return {
        type : FETCH_MONITORING_LIST_REQUEST,
        data
    }
}

export const fetchMonitoringListResponse = (data) => {
    return {
        type : FETCH_MONITORING_LIST_RESPONSE,
        data
    }
}


export const createMonitoringMetaDataRequest = (data) => {
    return {
        type : CREATE_MONITORING_METADATA_REQUEST,
        data
    }
}

export const createMonitoringMetaDataResponse = (data) => {
    return {
        type : CREATE_MONITORING_METADATA_RESPONSE,
        data
    }
}

export const startMonitoringProcessRequest = (data) => {
    return {
        type : UPLOAD_MONITORING_DATA_REQUEST,
        data
    }
}

export const startMonitoringProcessResponse = (data) => {
    return {
        type : UPLOAD_MONITORING_DATA_RESPONSE,
        data
    }
}


export const downloadMonitoringCrawlerStatusFileResponse =(data) => {
    return {
        type : DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_RESPONSE,
        data
    }
}

export const downloadMonitoringCrawlerStatusFileRequest =(data) => {
    return {
        type : DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_REQUEST,
        data
    }
}

export const downloadConsolidatedMonitoringReportRequest = (data) =>{
    return {
        type: DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_REQUEST,
        data
    }
}

export const downloadConsolidatedMonitoringReportResponse = (data) =>{
    return {
        type: DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_RESPONSE,
        data
    }
}



export const uploadMonitoringTemplateRequest = (data) => {
    return {
        type : UPLOAD_MONITORING_TEMPLATE_REQUEST,
        data
    }
}
 
export const uploadMonitoringTemplateResponse = (data) => {
    return {
        type : UPLOAD_MONITORING_TEMPLATE_RESPONSE,
        data
    }
}
 
export const initiateMonitoringRequest = (data) => {
    return {
        type : INITIATE_MONITORING_REQUEST,
        data
    }
}
 
export const initiateMonitoringResponse = (data) => {
    return {
        type : INITIATE_MONITORING_RESPONSE,
        data
    }
}
 
export const stopMonitoringRequest = (data) => {
    return {
        type : STOP_MONITORING_REQUEST,
        data
    }
}
 
export const stopMonitoringResponse = (data) => {
    return {
        type : STOP_MONITORING_RESPONSE,
        data
    }
}

export const CORPORATE_MONITORING_DATA_REQUEST = "CORPORATE_MONITORING_DATA_REQUEST";
export const CORPORATE_MONITORING_DATA_RESPONSE = "CORPORATE_MONITORING_DATA_RESPONSE";

export const fetchCorporateMonitoringRequest = (data) => {
    return {
        type : CORPORATE_MONITORING_DATA_REQUEST,
        data
    }
}

export const fetchCorporateMonitoringResponse = (data) => {
    return {
        type : CORPORATE_MONITORING_DATA_RESPONSE,
        data
    }
}



export const MONITORING_CORPORATE_LIST_REQUEST = "MONITORING_CORPORATE_LIST_REQUEST";
export const MONITORING_CORPORATE_LIST_RESPONSE = "MONITORING_CORPORATE_LIST_RESPONSE";

export const fetchMonitoringCorporateListRequest = (data) => {
    return {
        type : MONITORING_CORPORATE_LIST_REQUEST,
        data
    }
}

export const fetchMonitoringCorporateListResponse = (data) => {
    return {
        type : MONITORING_CORPORATE_LIST_RESPONSE,
        data
    }
}

export const DOWNLOAD_CORPORATE_MONITORING_REPORT_REQUEST = "DOWNLOAD_CORPORATE_MONITORING_REPORT_REQUEST";
export const DOWNLOAD_CORPORATE_MONITORING_REPORT_RESPONSE = "DOWNLOAD_CORPORATE_MONITORING_REPORT_RESPONSE";

export const downloadCorporateMonitoringReportRequest = (data) => {
    return {
        type : DOWNLOAD_CORPORATE_MONITORING_REPORT_REQUEST,
        data
    }
}

export const downloadCorporateMonitoringReportResponse = (data) => {
    return {
        type : DOWNLOAD_CORPORATE_MONITORING_REPORT_RESPONSE,
        data
    }
}

export const DOWNLOAD_EWS_REPORT_REQUEST = "DOWNLOAD_EWS_REPORT_REQUEST";
export const DOWNLOAD_EWS_REPORT_RESPONSE = "DOWNLOAD_EWS_REPORT_RESPONSE";

export const downloadEWSReportRequest = (data) => {
    return {
        type : DOWNLOAD_EWS_REPORT_REQUEST,
        data
    }
}

export const downloadEWSReportResponse = (data) => {
    return {
        type : DOWNLOAD_EWS_REPORT_RESPONSE,
        data
    }
}

export const EWS_PUBLISH_LIST_REQUEST = "EWS_PUBLISH_LIST_REQUEST";
export const EWS_PUBLISH_LIST_RESPONSE = "EWS_PUBLISH_LIST_RESPONSE";

export const ewsPublishListRequest = (data) => {
    return {
        type : EWS_PUBLISH_LIST_REQUEST,
        data
    }
}

export const ewsPublishListResponse = (data) => {
    return {
        type : EWS_PUBLISH_LIST_RESPONSE,
        data
    }
}

export const CORPORATE_EWS_DATA_REQUEST = "CORPORATE_EWS_DATA_REQUEST";
export const CORPORATE_EWS_DATA_RESPONSE = "CORPORATE_EWS_DATA_RESPONSE";

export const fetchCorporateEwsRequest = (data) => {
    return {
        type : CORPORATE_EWS_DATA_REQUEST,
        data
    }
}

export const fetchCorporateEwsResponse = (data) => {
    return {
        type : CORPORATE_EWS_DATA_RESPONSE,
        data
    }
}

export const SEND_CORPORATE_MONITORING_REPORT_REQUEST = "SEND_CORPORATE_MONITORING_REPORT_REQUEST";
export const SEND_CORPORATE_MONITORING_REPORT_RESPONSE = "SEND_CORPORATE_MONITORING_REPORT_RESPONSE";

export const sendCorporateMonitoringReportRequest = (data) => {
    return {
        type : SEND_CORPORATE_MONITORING_REPORT_REQUEST,
        data
    }
}

export const sendCorporateMonitoringReportResponse = (data) => {
    return {
        type : SEND_CORPORATE_MONITORING_REPORT_RESPONSE,
        data
    }
}

export const SEND_MONITORING_BULK_REPORT_REQUEST = "SEND_MONITORING_BULK_REPORT_REQUEST";
export const SEND_MONITORING_BULK_REPORT_RESPONSE = "SEND_MONITORING_BULK_REPORT_RESPONSE";

export const sendCorporateMonitoringBulkReportRequest = (data) => {
    return {
        type : SEND_MONITORING_BULK_REPORT_REQUEST,
        data
    }
}

export const sendCorporateMonitoringBulkReportResponse = (data) => {
    return {
        type : SEND_MONITORING_BULK_REPORT_RESPONSE,
        data
    }
}



export const DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_REQUEST = "DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_REQUEST";
export const DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_RESPONSE = "DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_RESPONSE";

export const downloadMonitoringScoreCalcultionTemplateRequest= (data) => {
    return {
        type : DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_REQUEST,
        data
    }
}

export const downloadMonitoringScoreCalcultionTemplateResponse= (data) => {
    return {
        type : DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_RESPONSE,
        data
    }
}

export const PUBLISH_MONITORING_REPORT_REQUEST = "monitoring/PUBLISH_MONITORING_REPORT_REQUEST";
export const PUBLISH_MONITORING_REPORT_RESPONSE = "monitoring/PUBLISH_MONITORING_REPORT_RESPONSE";

export const publishMonitoringReportRequest = (data) => {
    return {
        type :  PUBLISH_MONITORING_REPORT_REQUEST,
        data
    }
}

export const publishMonitoringReportResponse = (data) => {
    return {
        type :  PUBLISH_MONITORING_REPORT_RESPONSE,
        data
    }
}

export const DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_REQUEST = "monitoring/DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_REQUEST";
export const DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_RESPONSE = "monitoring/DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_RESPONSE";

export const downlodOldOrOfflineDataUploadTemplateRequest = (data) => {
    return {
        type : DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_REQUEST,
        data
    }
}

export const downlodOldOrOfflineDataUploadTemplateResponse = (data) => {
    return {
        type : DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_RESPONSE,
        data
    }
}